import React, { useState, useEffect } from "react";
import "./OfferSection..css";
import { useAnalytics } from "../../hooks/useAnalytics";

const OfferSection = () => {
  useAnalytics();
  
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    "/shortletslideshow3.webp",
    "/shortletsslideshow1.webp",
    "/shortletsslideshow2.webp",
    "/shortletslideshow4.webp",
    // "https://nimbleletprodstorage.blob.core.windows.net/web-images/shortlet slideshow 3.jpg",
    // "/https://nimbleletprodstorage.blob.core.windows.net/web-images/shortlet slideshow 4.jpg",
    // "/https://nimbleletprodstorage.blob.core.windows.net/web-images/shortlets slideshow 1.jpg",
    // "/https://nimbleletprodstorage.blob.core.windows.net/web-images/shortlets slideshow 2.jpg",
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev === slides.length - 1 ? 0 : prev + 1));
    }, 3000);
    return () => clearInterval(timer);
  }, [slides.length]);

  return (
    <div className="rental-container">
      {/* slide Section */}
      <div className="slide-section">
        <div className="slideshow-container">
          {slides.map((slide, index) => (
            <div
              key={index}
              className={`slide ${currentSlide === index ? "active" : ""}`}
            >
              <img src={slide} alt={`Slide ${index + 1}`} />
            </div>
          ))}
        </div>

        <div className="slide-content">
          <h1>Find Your Perfect Stay, In Minutes!!</h1>
          <p>
            Explore a variety of shortlet rentals to match your style and
            budget.
          </p>
        </div>
      </div>

      {/* What we Offer Section */}
      <section className="offer-section">
        <h2>What we Offer</h2>

        <div className="offer-grid">
          <div className="offer-card">
            <div className="offer-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="26"
                height="26"
                fill="currentColor"
                class="bi bi-geo-alt-fill"
                viewBox="0 0 16 16"
                color="#EE7B0D"
              >
                <path d="M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10m0-7a3 3 0 1 1 0-6 3 3 0 0 1 0 6" />
              </svg>
            </div>
            <div className="offer-content">
              <h3>Location</h3>
              <p>Easy access to prime locations in Lagos to fit your style.</p>
            </div>
          </div>

          <div className="offer-card">
            <div className="offer-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="26"
                height="26"
                fill="currentColor"
                class="bi bi-basket2-fill"
                viewBox="0 0 16 16"
                color="#EE7B0D"
              >
                <path d="M5.929 1.757a.5.5 0 1 0-.858-.514L2.217 6H.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h.623l1.844 6.456A.75.75 0 0 0 3.69 15h8.622a.75.75 0 0 0 .722-.544L14.877 8h.623a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1.717L10.93 1.243a.5.5 0 1 0-.858.514L12.617 6H3.383zM4 10a1 1 0 0 1 2 0v2a1 1 0 1 1-2 0zm3 0a1 1 0 0 1 2 0v2a1 1 0 1 1-2 0zm4-1a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0v-2a1 1 0 0 1 1-1" />
              </svg>
            </div>
            <div className="offer-content">
              <h3>Amenities</h3>
              <p>
                State of the art amenities in every facility for a comfortable
                stay.
              </p>
            </div>
          </div>

          <div className="offer-card">
            <div className="offer-icon">
              <svg
                width="26"
                height="26"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7.5 18C8.41684 17.0229 9.72299 16.5115 11.0315 16.5002M13 12C13 13.1046 12.1187 14 11.0315 14C9.94438 14 9.06307 13.1046 9.06307 12C9.06307 10.8954 9.94438 10 11.0315 10C12.1187 10 13 10.8954 13 12Z"
                  stroke="#EE7B0D"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                />
                <path
                  d="M8.5 4.00098C5.85561 4.01083 4.44101 4.1033 3.52513 4.97097C2.5 5.94215 2.5 7.50522 2.5 10.6314V15.3682C2.5 18.4944 2.5 20.0575 3.52513 21.0286C4.55025 21.9998 6.20017 21.9998 9.5 21.9998H11.5M13.5 4.00098C16.1444 4.01083 17.559 4.1033 18.4749 4.97097C19.5 5.94215 19.5 7.50522 19.5 10.6314V11.4998"
                  stroke="#EE7B0D"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M8.77216 3.63163C8.8681 3.21682 8.91608 3.00942 9.00821 2.84004C9.22285 2.44546 9.61879 2.15548 10.0914 2.0467C10.2943 2 10.5296 2 11 2C11.4704 2 11.7057 2 11.9086 2.0467C12.3812 2.15548 12.7771 2.44545 12.9918 2.84004C13.0839 3.00942 13.1319 3.21682 13.2278 3.63163L13.3111 3.99176C13.4813 4.72744 13.5664 5.09528 13.438 5.37824C13.3549 5.5615 13.2132 5.71842 13.031 5.82911C12.7496 6 12.3324 6 11.4981 6H10.5019C9.66755 6 9.25038 6 8.96901 5.82911C8.78677 5.71842 8.6451 5.5615 8.56197 5.37824C8.43361 5.09528 8.51869 4.72744 8.68886 3.99176L8.77216 3.63163Z"
                  stroke="#EE7B0D"
                  strokeWidth="1.5"
                />
                <path
                  d="M16.4896 17.7675C16.1157 17.5892 15.6681 17.7477 15.4898 18.1215C15.3114 18.4954 15.4699 18.943 15.8437 19.1214L16.4896 17.7675ZM17.0556 19.3333L16.4094 19.7141C16.55 19.9528 16.8109 20.0945 17.0877 20.0826C17.3645 20.0708 17.6123 19.9072 17.732 19.6573L17.0556 19.3333ZM19.1888 17.7715C19.5536 17.5752 19.6901 17.1203 19.4937 16.7556C19.2974 16.3909 18.8425 16.2544 18.4778 16.4507L19.1888 17.7715ZM20.75 18C20.75 19.7949 19.2949 21.25 17.5 21.25V22.75C20.1234 22.75 22.25 20.6234 22.25 18H20.75ZM17.5 21.25C15.7051 21.25 14.25 19.7949 14.25 18H12.75C12.75 20.6234 14.8766 22.75 17.5 22.75V21.25ZM14.25 18C14.25 16.2051 15.7051 14.75 17.5 14.75V13.25C14.8766 13.25 12.75 15.3766 12.75 18H14.25ZM17.5 14.75C19.2949 14.75 20.75 16.2051 20.75 18H22.25C22.25 15.3766 20.1234 13.25 17.5 13.25V14.75Z"
                  fill="#EE7B0D"
                />
              </svg>
            </div>
            <div className="offer-content">
              <h3>Easy Sign-Up</h3>
              <p>
                Create an account as a host in few minutes and start posting
                your shortlet immediately.
              </p>
            </div>
          </div>

          <div className="offer-card">
            <div className="offer-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="26"
                height="26"
                fill="currentColor"
                class="bi bi-person-hearts"
                viewBox="0 0 16 16"
                color="#EE7B0D"
              >
                <path
                  fill-rule="evenodd"
                  d="M11.5 1.246c.832-.855 2.913.642 0 2.566-2.913-1.924-.832-3.421 0-2.566M9 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0m-9 8c0 1 1 1 1 1h10s1 0 1-1-1-4-6-4-6 3-6 4m13.5-8.09c1.387-1.425 4.855 1.07 0 4.277-4.854-3.207-1.387-5.702 0-4.276ZM15 2.165c.555-.57 1.942.428 0 1.711-1.942-1.283-.555-2.281 0-1.71Z"
                />
              </svg>
            </div>
            <div className="offer-content">
              <h3>Guest Satisfaction</h3>
              <p>
                We prioritize maintaining a 5 star experience for every guest.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default OfferSection;
